import React, { useState } from "react";
import SidebarMenuItem from "./SidebarMenuItem";
import { classNames } from "../../helpers/classNames";

const SidebarMenuBlocks = ({ menuTitle, menuData, isMenuOpen, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      <div className="relative py-2 px-4 transition-all duration-100">
        {menuTitle && (
          <div
            className="flex items-center justify-between text-xs uppercase text-blue-zodiac font-bold cursor-pointer"
            onClick={handleToggle}
          >
            <span>{menuTitle}</span>
            <div>
              {isExpanded ? (
                <i className="fa-solid fa-chevron-down h-4 w-4 text-slate-800" />
              ) : (
                <i className="fa-solid fa-chevron-up h-4 w-4 text-slate-800" />
              )}
            </div>
          </div>
        )}
        <div
          className={classNames(
            "transition-all duration-200 overflow-hidden -mx-2 px-2",
            !isExpanded || !menuTitle ? "max-h-[2000px]" : "max-h-0"
          )}
        >
          <div className="space-y-1">
            {menuData?.map((item, i) => (
              <SidebarMenuItem
                key={item?._id + i}
                menuLink={item.menuLink}
                menuIcon={item.menuIcon}
                menuIconColor={item.menuIconColor}
                menuLabel={item.menuLabel}
                isMenuOpen={isMenuOpen}
                blank={item?.blank}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarMenuBlocks;
